// src/pages/RegistroInterventiPage.js
// Gestione → Registri → Registro interventi: si sceglie il cliente e si apre il suo registro.
// Tutta la logica è in components/RegistroInterventi.js (usato anche dentro la commessa).
import React from "react";
import RegistroInterventi from "../components/RegistroInterventi";

export default function RegistroInterventiPage() {
  return <RegistroInterventi/>;
}
